import { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { useNavigate } from "react-router";
import bulbImage from "../../../images/buld.png";
import Footer from "../../../core/common/footer/Footer";
import useApi from "../../../core/customhook/useApi";
import { useSelector } from "react-redux";
import { RootState } from "../../../core/data/redux/store";
import SnipperLoader from "../../../core/common/loader/SnipperLoader";
import { disabledStatuses } from "../../../core/common/DateValidHelper";

const qualifications = [
  {
    label: "Post Graduation/Master degree",
    value: "post_graduation",
  },
  {
    label: "Bachelor's Degree",
    value: "graduation",
  },
  {
    label: "Diploma/Professional Certification",
    value: "diploma_professional_certification",
  },
  {
    label: "12th Standard India",
    value: "12th_standard",
  },
  {
    label: "10th Standard India",
    value: "10th_standard",
  },
];

const FirstEducationForm = () => {
  const navigate = useNavigate();
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedQualification, setSelectedQualification] = useState("");

  const visibleQualifications = !selectedCountry
    ? qualifications // Default: show all
    : selectedCountry === "India"
      ? qualifications // India: show all 5
      : qualifications.slice(0, 3); // Other countries: show first 3

  const templates = useSelector((state: RootState) => state.package.templates);

  const educationTemplate = templates.find(
    (item: any) => item.check_name === "Highest Education",
  );

  const assignmentTemplateId = educationTemplate?.assignment_template_id;
  const templateStatus = educationTemplate?.status;

  const formFieldsAPI = useApi<any>(
    `/api/v1/candidate/templates/${assignmentTemplateId}`,
    {
      method: "GET",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const getQualification = async () => {
    try {
      const res = await formFieldsAPI.callApi();

      if (res?.success) {
        const formType = res?.data?.form_type || "";

        // Auto-select if API returns value
        setSelectedQualification(formType);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (assignmentTemplateId) {
      getQualification();
    }
  }, [assignmentTemplateId]);


  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-lg-8">
              {/* Main Form */}
              {formFieldsAPI.loading ? (
                <SnipperLoader />
              ) : (
                <div className="card overflow-hidden">
                  <div className="p-3 p-md-4">
                    {/* Heading */}
                    <p
                      className="fw-bold text-dark mb-2"
                      style={{
                        fontSize: "20px",
                        lineHeight: "28px",
                      }}
                    >
                      {selectedQualification
                        ? `Selected Qualification: ${
                            visibleQualifications.find(
                              (item) => item.value === selectedQualification,
                            )?.label
                          }`
                        : "Please select Highest Education Qualification"}
                    </p>

                    <hr className="mb-4 text-dark bg-dark" />

                    {/* Checkbox List */}
                    <div className="d-flex flex-column gap-3">
                      {visibleQualifications.map((item, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-start gap-2"
                        >
                          <input
                            id={`qualification-${item.value}`}
                            type="checkbox"
                            className="form-check-input mt-1"
                            checked={selectedQualification === item.value}
                            onChange={() =>
                              setSelectedQualification(
                                selectedQualification === item.value
                                  ? ""
                                  : item.value,
                              )
                            }
                            disabled={disabledStatuses.includes(
                              templateStatus ?? "",
                            )}
                          />

                          <label
                            htmlFor={`qualification-${item.value}`}
                            className="text-dark"
                            style={{ cursor: "pointer" }}
                          >
                            {item.label}
                          </label>
                        </div>
                      ))}
                    </div>

                    {/* Submit Button */}
                    <div className="d-flex justify-content-end mt-4">
                      <button
                        className="btn btn-primary"
                        disabled={!selectedQualification}
                        onClick={() =>
                          navigate(
                            `${all_routes.superAdminDashboard}?module=secondEducationForm`,
                            {
                              state: {
                                qualification: selectedQualification,
                              },
                            },
                          )
                        }
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="col-md-4">
              <div
                style={{
                  position: "sticky",
                  top: "60px",
                  alignSelf: "flex-start",
                }}
              >
                <div className="card border-0 shadow-sm">
                  {/* Header */}
                  <div
                    className="text-center py-4"
                    style={{ backgroundColor: "#f7f1e3" }}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center mx-auto mb-2 rounded-circle bg-white"
                      style={{ width: "70px", height: "70px" }}
                    >
                      {/* <i
                      className="bi bi-lightbulb-fill text-warning"
                      style={{ fontSize: "35px" }}
                    ></i> */}
                      <img src={bulbImage} alt="buld" />
                    </div>

                    <h6 className="fw-bold mb-0">Instructions</h6>
                  </div>

                  {/* Body */}
                  <div className="card-body">
                    {/* Instruction 1 */}
                    <div className="d-flex mb-4">
                      <div
                        className="rounded me-3 mt-1 flex-shrink-0"
                        style={{
                          width: "16px",
                          height: "16px",
                          backgroundColor: "#f4c542",
                        }}
                      ></div>

                      <div>
                        <h6 className="mb-1 fw-semibold">Instruction 1</h6>
                        <p className="text-muted mb-0 small">
                          Please provide your relevant education details in the
                          form, and ensure that the relevant document mentions
                          your name exactly as it appears on the official
                          education documents.
                        </p>
                      </div>
                    </div>

                    {/* Instruction 2 */}
                    <div className="d-flex mb-4">
                      <div
                        className="rounded me-3 mt-1 flex-shrink-0"
                        style={{
                          width: "16px",
                          height: "16px",
                          backgroundColor: "#f4c542",
                        }}
                      ></div>

                      <div>
                        <h6 className="mb-1 fw-semibold">Instruction 2</h6>

                        <p className="text-muted mb-0 small">
                          In case you changed your name later due to
                          marriage/other reason we have already captured that in
                          the personal informant section.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default FirstEducationForm;
